import React from 'react';
import { LoadingExamples } from '@/components/common';

export default function LoadingExamplesPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <LoadingExamples />
    </div>
  );
}
